//import Resizer from "react-image-file-resizer";

export async function resizeFile(file, newWidth, newHeight, maxSizeInMB = 0.5) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (event) {
            const img = new Image();
            img.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Calcular el nuevo tamaño proporcional
                const aspectRatio = img.width / img.height;
                let width = newWidth;
                let height = newHeight;
                if (!width) {
                    width = height * aspectRatio;
                } else if (!height) {
                    height = width / aspectRatio;
                }

                // Establecer el nuevo tamaño del lienzo (canvas)
                canvas.width = width;
                canvas.height = height;

                // Dibujar la imagen en el lienzo con el nuevo tamaño
                ctx.drawImage(img, 0, 0, width, height);

                // Convertir el lienzo a un nuevo archivo Blob
                canvas.toBlob(
                    (blob) => {
                        // Check if resized file is still too large
                        const maxBytes = maxSizeInMB * 1024 * 1024;
                        if (blob.size > maxBytes) {
                            reject(new Error(`Resized file still too large: ${(blob.size / 1024 / 1024).toFixed(2)}MB`));
                            return;
                        }
                        const resizedFile = new File([blob], file.name, {
                            type: file.type,
                            lastModified: Date.now(),
                        });
                        resolve(resizedFile);
                    },
                    file.type,
                    0.8 // Reduce quality to 80% for better compression
                );
            };
            img.onerror = function (error) {
                reject(error);
            };
            img.src = event.target.result;
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.readAsDataURL(file);
    });
}